import React, { Component } from 'react';
import { Tabs, Tab, Box, Link, Stack, Typography } from '@mui/material';
import TabPanel from '../common/TabPanel';
import DetailsContent from './DetailsContent';
import { CHECKLIST_YES_INDICATOR } from '../common/constants';
import { FormDropDown } from '../common/Form/FormDropdown';
import { WithSmallScreen } from '../common/WithSmallScreen';

class DetailsTabs extends Component {
  state = {
    tabSelected: 0,
    requiredItems: [],
    optionalItems: [],
    itemsExpansionStatus: {},
  };

  componentDidMount() {
    const { requiredItems, optionalItems } = this.props.items.reduce(
      ({ requiredItems, optionalItems }, item) => {
        if (item.itemRequiredInd === CHECKLIST_YES_INDICATOR) {
          requiredItems.push(item);
        } else {
          optionalItems.push(item);
        }
        return { requiredItems, optionalItems };
      },
      { requiredItems: [], optionalItems: [] },
    );

    const itemsExpansionStatus = {};
    this.props.items.forEach((item) => {
      itemsExpansionStatus[item.itemTimeCode] = true;
    });

    this.setState({ requiredItems, optionalItems, itemsExpansionStatus });
  }

  onChange = (event, value) => {
    this.setState({ tabSelected: value });
  };

  toggleItemExpansionStatus = (itemTimeCode, value) => {
    this.setState({
      itemsExpansionStatus: {
        ...this.state.itemsExpansionStatus,
        [itemTimeCode]: value,
      },
    });
  };

  setExpansionBulk = (items, value) => {
    const updated = { ...this.state.itemsExpansionStatus };
    items.forEach((item) => {
      updated[item.itemTimeCode] = value;
    });
    this.setState({ itemsExpansionStatus: updated });
  };

  //double check if ODU globlal.
  //time code start with o is the official way, but need double checl
  isODUGlobalChecklist = () => {
    return (
      this.props.checklistTimeCode?.toLowerCase().startsWith('o') ||
      this.props.items?.some((item) => item.title?.toLowerCase().includes('oduglobal'))
    );
  };

  render() {
    const isODUGlobal = this.isODUGlobalChecklist();

    return (
      <>
        {isODUGlobal && (
          <Box className="checklistCallout">
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography component="p">
                For questions about this checklist, contact{' '}
                <Link href="mailto:GlobalOrientation@odu.edu">GlobalOrientation@odu.edu</Link>.
              </Typography>
            </Stack>
          </Box>
        )}
        <Box sx={{ width: '100%', pb: 1 }}>
          {this.props.isSmall ? (
            <FormDropDown
              options={['All Items', 'Required', 'Optional'].map((term, index) => ({
                value: index,
                label: term,
              }))}
              value={this.state.tabSelected}
              onChange={(e) => this.onChange(null, e.target.value)}
              ariaLabel={'Choose items'}
              id="checklist__dropdown_mobilePickItems"
            />
          ) : (
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs
                className="myOdu__tabs"
                value={this.state.tabSelected}
                onChange={this.onChange}
                aria-label="Checklists Details Tabs"
              >
                <Tab
                  label="All Items"
                  id="checklists__tab_all_items"
                  aria-controls={'checklists__tabpanel_all_items'}
                />
                <Tab
                  label="Required"
                  id="checklists__tab_required"
                  aria-controls={'checklists__tabpanel_required'}
                />
                <Tab
                  label="Optional"
                  id="checklists__tab_optional"
                  aria-controls={'checklists__tabpanel_optional'}
                />
              </Tabs>
            </Box>
          )}
        </Box>

        <TabPanel
          value={this.state.tabSelected}
          sx={{ pt: 1, px: 0 }}
          index={0}
          id="checklists__tabpanel_all_items"
          labelledby="checklists__tab_all_items"
        >
          <DetailsContent
            items={this.props.items}
            isLoading={this.props.isLoading}
            checklistTitle={this.props.checklistTitle}
            checklistTimeCode={this.props.checklistTimeCode}
            tabSelected={this.state.tabSelected}
            itemsExpansionStatus={this.state.itemsExpansionStatus}
            toggleItemExpansionStatus={this.toggleItemExpansionStatus}
            setExpansionBulk={this.setExpansionBulk}
          />
        </TabPanel>

        <TabPanel
          value={this.state.tabSelected}
          sx={{ pt: 1, px: 0 }}
          index={1}
          id="checklists__tabpanel_required"
          labelledby="checklists__tab_required"
        >
          <DetailsContent
            items={this.state.requiredItems}
            isLoading={this.props.isLoading}
            checklistTitle={this.props.checklistTitle}
            checklistTimeCode={this.props.checklistTimeCode}
            tabSelected={this.state.tabSelected}
            itemsExpansionStatus={this.state.itemsExpansionStatus}
            toggleItemExpansionStatus={this.toggleItemExpansionStatus}
            setExpansionBulk={this.setExpansionBulk}
          />
        </TabPanel>

        <TabPanel
          value={this.state.tabSelected}
          sx={{ pt: 1, px: 0 }}
          index={2}
          id="checklists__tabpanel_optional"
          labelledby="checklists__tab_optional"
        >
          <DetailsContent
            items={this.state.optionalItems}
            isLoading={this.props.isLoading}
            checklistTitle={this.props.checklistTitle}
            checklistTimeCode={this.props.checklistTimeCode}
            tabSelected={this.state.tabSelected}
            itemsExpansionStatus={this.state.itemsExpansionStatus}
            toggleItemExpansionStatus={this.toggleItemExpansionStatus}
            setExpansionBulk={this.setExpansionBulk}
          />
        </TabPanel>
      </>
    );
  }
}

export default WithSmallScreen(DetailsTabs);
